// extracted by mini-css-extract-plugin
export default {"stepsCardBlockWrapper":"style-module--stepsCardBlockWrapper--61a1e","stepsCardBlock":"style-module--stepsCardBlock--daad7"};